<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :submit="submit"
    :status="status"
    :canCancel="false"
    :canUpdateDelete="false"
    next-link="/admin/privacy"
    :breadcrumbs="[
        {
          text: 'Configuración y politicas',
          disabled: false,
          href: '#'
        },
        {
          text: 'Modo de Verificación',
          disabled: false,
          href: '#'
        }
      ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="6">
          <v-row no-gutters justify="center">
            <v-col class="d-flex justify-center">
              <ValidationProvider
                ref="name"
                rules="required"
                v-slot="{ errors }"
              >
                <v-checkbox
                  v-model="data.is_automatic"
                  class="input-check-base mt-5"
                  hide-details="auto"
                  on-icon="$checkedIcon"
                  off-icon="$unCheckedIcon"
                  label="Automatico"
                ></v-checkbox>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import Swal from "sweetalert";
export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },
  data() {
    return {
      storeName: "Verifications",
      title: "Modo de Verificación",
      data: {
        is_automatic: "",
      },
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Tags.status,
    }),
  },
  watch: {},
  methods: {
    async submit() {
      const self = this;
      let valid = await self.$refs.validator.validate();
      if (valid) {
        let saveUrl = this.$route.params.id
          ? `${this.storeName}/update`
          : `${this.storeName}/create`;
        self.$store
          .dispatch(saveUrl, self.data)
          .then(function() {
            Swal(
              "Modo de verificacón Actualizada",
              "existosamente",
              "success",
              {
                buttons: false,
                timer: 3000,
              }
            );
          })
          .catch(function(response) {
            for (const i in response.errors) {
              try {
                eval("self.$refs." + i + ".setErrors(response.errors[i]);");
              } catch (error) {
                //
              }
            }
          });
      }
    },
  },
};
</script>
